import { UIConfig, UIPagesConfigMap } from '../../shared/models/ui-config.model';
import { PageKey } from '../../shared/models/page-key.enum';
import { FiltersDictionary } from '../../shared/models/filter.model';
import { FilterSchema, FilterSchemaItem, FilterSelectionType } from './filter.types';

function normalizeType(t: string): FilterSelectionType {
  if (t === 'multi') return 'multi';
  if (t === 'boolean') return 'boolean';
  if (t === 'text') return 'text';
  return 'multi';
}

export function buildFilterSchemaFromUiConfig(config: UIConfig | null | undefined): FilterSchema {
  const dictionary: FiltersDictionary | undefined = config?.filters?.filters;
  const filters: FilterSchema['filters'] = {};
  for (const [id, def] of Object.entries(dictionary || {})) {
    if (def.type === 'dateRange') continue; // handled separately by FilterBar
    filters[id] = {
      displayName: def.label,
      // Prefer explicit backend column when provided in tenant config.
      column: def.column || def.field,
      type: normalizeType(def.type),
      default: def.defaultValue,
      defaultOperator: def.defaultOperator,
      options: def.options,
      // pass through UI metadata for API-backed options
      source: def.source,
      fetchDistinct: def.fetchDistinct,
      orderDirection: def.orderDirection,
      pluralLabel: def.pluralLabel,
      displayFormat: def.displayFormat,
    } as FilterSchemaItem;
  }
  // Build page applicability from UIConfig pages if provided
  const pages: UIPagesConfigMap | undefined = config?.pages;
  const pageApplicability: Partial<Record<PageKey, string[]>> = {};
  if (pages) {
    for (const [pageKey, pageCfg] of Object.entries(pages)) {
      const allowed = pageCfg.filters?.allowedIds;
      const includeGlobal = pageCfg.filters?.includeGlobal !== false; // default true
      if (allowed || includeGlobal) {
        const base = includeGlobal ? Object.keys(filters) : [];
        const merged = new Set([...(base || []), ...(allowed || [])]);
        pageApplicability[pageKey as PageKey] = Array.from(merged);
      }
    }
  }
  return { filters, pageApplicability };
}
